/**
 * 追加オプション対応版 ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      // ボタンのクリックイベントを「親要素」で受け取る（デリゲート）
      // これにより、HTMLが差し替えられてもイベントが途切れません
      this.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    async onSubmitHandler(event) {
      event.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (!submitButton || submitButton.classList.contains('loading')) return;

      console.log('--- 送信処理開始 ---');

      // 1. 商品情報の取得
      const form = this.querySelector('form');
      const formData = new FormData(form);
      const mainVariantId = formData.get('id');
      const quantity = formData.get('quantity') || 1;

      console.log('取得データ:', { mainVariantId, quantity });

      if (!mainVariantId) {
        alert('商品の情報を取得できませんでした。');
        return;
      }

      let items = [{ id: mainVariantId, quantity: parseInt(quantity) }];

      console.log('送信データ:', items);

      // ローディング開始
      if (submitButton) {
        submitButton.classList.add('loading');
        submitButton.setAttribute('aria-busy', 'true');
      }

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });

        if (response.ok) {
          console.log('成功！カートへ移動します');
          window.location.href = '/cart';
        } else {
          const err = await response.json();
          alert('エラー: ' + (err.description || '追加に失敗しました'));
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-busy');
        }
      } catch (e) {
        console.error('通信エラー:', e);
        if (submitButton) {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-busy');
        }
      }
    }

    // テーマが必要とする空のメソッド（エラー回避）
    toggleSubmitButton() {}
    handleErrorMessage() {}
  });
}